var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":_vm.linkTarget,"target":_vm.htmlTarget,"title":_vm.model.caption},on:{"click":_vm.handleClick}},[_vm._t("default",[_vm._v(_vm._s(_vm.model.caption))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }